import { render, staticRenderFns } from "./ProfileCompany.vue?vue&type=template&id=28545bd8"
import script from "./ProfileCompany.vue?vue&type=script&lang=js"
export * from "./ProfileCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports